import React, { type PropsWithChildren } from 'react';
import { StyleSheet } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { useStyle } from 'react-native-style-utilities';

import { theme } from '@garnish/constants';
import { Container, useContainerSpacing, useResponsive } from '@garnish/core';

// ─────────────────────────────────────────────────────────────────────────────

export const MenuHeaderContentContainer = (props: Props) => {
  const { children, dataSet } = props;

  const { currentBreakpoint } = useResponsive();
  const containerSpacing = useContainerSpacing();
  const { right: safeAreaRightInset, left: safeAreaLeftInset } = useSafeAreaInsets();

  // ─── Styles ────────────────────────────────────────────────────────────────

  const containerDynamicStyle = useStyle(() => {
    if (currentBreakpoint.isLG) {
      return;
    }

    return {
      paddingRight: Math.max(safeAreaRightInset, containerSpacing),
      paddingLeft: Math.max(safeAreaLeftInset, containerSpacing),
    };
  }, [currentBreakpoint.isLG, containerSpacing, safeAreaRightInset, safeAreaLeftInset]);
  const containerStyles = [styles.container, containerDynamicStyle];

  // ───────────────────────────────────────────────────────────────────────────

  return (
    <Container
      removeSpacing={currentBreakpoint.isLG}
      style={containerStyles}
      {...(dataSet ? { dataSet } : {})}
    >
      {children}
    </Container>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: theme.spacing['4'],
    marginBottom: theme.spacing['4'],
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = PropsWithChildren<{
  dataSet?: Record<string, string>;
}>;
